import { render, staticRenderFns } from "./list-feedback.vue?vue&type=template&id=c19401f8&scoped=true"
import script from "./list-feedback.vue?vue&type=script&lang=js"
export * from "./list-feedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19401f8",
  null
  
)

export default component.exports